import {useRef, useState} from 'react';

import {TrashRegularIcon} from 'shells/icon';
import type {ToolbarOption} from 'shells/toolbar/toolbar';

import {CoreEntityConfirmationDialog} from '../../core-entity-confirmation-dialog/core-entity-confirmation-dialog';

import {BaseRow} from '../base-row/base-row';

interface Props {
    title: string;
    isWebFX: boolean;
    onRemove: () => void;
}

export function AudienceRow(props: Props) {
    const [isRemoveConfirmationOpen, setIsRemoveConfirmationOpen] = useState<boolean>(false);
    const [forceToolbarOpen, setForceToolbarOpen] = useState<boolean>(false);

    const removeButtonRef = useRef<HTMLElement | null | undefined>(null);

    const handleRemove = () => {
        setIsRemoveConfirmationOpen(false);
        setForceToolbarOpen(false);
        props.onRemove();
    };

    const toolbarOptions: ToolbarOption[] = [];
    if (!props.isWebFX) {
        toolbarOptions.push({
            id: 'remove-from-person-from-audience',
            tooltipText: 'Remove from audience',
            icon: TrashRegularIcon,
            onClick: () => {
                setIsRemoveConfirmationOpen(true);
                setForceToolbarOpen(true);
            },
            getRef: (ref) => {
                removeButtonRef.current = ref;
            },
        });
    }
    return (
        <>
            <BaseRow
                type='audience'
                onClick={() => {}}
                title={props.title}
                toolbarProps={{options: toolbarOptions, forceShowToolbar: forceToolbarOpen}}
            >
                <></>
            </BaseRow>
            {isRemoveConfirmationOpen && (
                <CoreEntityConfirmationDialog
                    anchor={removeButtonRef.current}
                    type='audience'
                    parentEntity='person'
                    onConfirm={handleRemove}
                    onCancel={() => {
                        setIsRemoveConfirmationOpen(false);
                        setForceToolbarOpen(false);
                    }}
                />
            )}
        </>
    );
}
